import { Outlet, useParams } from 'react-router-dom'

import useCanEditRole from 'modules/job_catalog/hooks/useCanEditRole'
import { useRole } from 'modules/job_catalog/hooks/useRole'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useCompetenciesFeatureAvailability } from 'modules/reviews/hooks/usePerformanceModuleFeatureAvailabilities'

function Component() {
  const { id } = useParams<{ id: string }>()
  const [role, isFetching] = useRole(Number(id))
  const [canEditRole, isLoading] = useCanEditRole(role)
  const { loading: loadingCompetenciesAvailability, competenciesAvailable } =
    useCompetenciesFeatureAvailability()

  if (!role) {
    return null
  }

  return (
    <ResponsivePage.Body variant="full" showHeader={false}>
      <Outlet
        context={{
          role,
          canEditRole,
          isLoading: isFetching || isLoading || loadingCompetenciesAvailability,
          competenciesAvailable: competenciesAvailable,
        }}
      />
    </ResponsivePage.Body>
  )
}

export default Component
